// extracted by mini-css-extract-plugin
module.exports = {"container":"search-bar-pop-up-module__container___g-lTO","search":"search-bar-pop-up-module__search___rkfSy","searchDesktop":"search-bar-pop-up-module__searchDesktop___DTGku"};